import axios from 'axios';
import { NULL } from 'sass';
import store from '../../store';

const model = () => {
	return {
		new_id:			'',
		username: 		'',
		password: 		'',
		note: 			'',
		email:			'',
		update_version: null
	};
};

const save = async (model) => {
	// Remove blank email and update_version
	if (model.email == '') delete model.email;
	if (model.update_version === null || model.update_version == '' || model.update_version == 1) model.update_version = null;

	try {
		return model.id ? await axios.put(`/clients/${model.id}`, model) : await axios.post(`/clients`, model);
	} catch (err) {
		return false;
	}
};

const read = async(id) => {
	return (await axios.get(`/clients/${id}`)).data;
};

const window = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'client-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const send = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'send-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const open = async (id, onSave) => {
	window(id ? await read(id) : model(), async (model) => {
		const r = await save(model);

		if (r) {
			if (onSave) onSave(r);
			return true;
		}

		return false;
	});
};

const del = async (id) => {
	await axios.delete(`/clients/${id}`);
};

export default {
	model,
	save,
	read,
	open,
	window,
	del,
	send
};